<app-card class="page-container">
  <app-card-header>
    <app-card-title>
      <div class="header-content">
        <app-icon name="clipboard-pen" />
        <span>{{ 'submission.record.title' | translate }}</span>
      </div>
    </app-card-title>
  </app-card-header>

  <app-card-content class="scrollable-content">
    <!-- Loading State -->
    @if (loading()) {
    <div class="loading-container">
      <app-spinner />
      <p>{{ 'submission.record.loading' | translate }}</p>
    </div>
    }

    <!-- Error State -->
    @if ((error() || initError()) && !loading()) {
    <div class="error-message" data-testid="error-message">
      <app-icon name="alert-circle" />
      <p>{{ error() || initError() }}</p>
      <app-button (click)="backToScan()" data-testid="back-to-scan-button">
        <app-icon name="arrow-left" />
        {{ 'submission.record.backToScan' | translate }}
      </app-button>
    </div>
    }

    <!-- Asset Info and Interaction Type Selection -->
    @if (!loading() && !(error() || initError()) && checkPoint()) {
    <div class="content-container">
      <!-- Asset Info -->
      <div class="checkPoint-info" data-testid="asset-info">
        <h3>{{ checkPoint()!.name }}</h3>
        @if (checkPoint()!.description) {
        <p>{{ checkPoint()!.description }}</p>
        }
      </div>

      <!-- Interaction Type Selection -->
      <div class="forms-section">
        <h4>{{ 'submission.record.selectType' | translate }}</h4>
        <p class="instructions">{{ 'submission.record.instructions' | translate }}</p>

        <div class="form-list">
          @for (form of forms(); track form.id) {
          <button class="form-card" (click)="selectForm(form)" [attr.data-testid]="'interaction-type-' + form.id">
            <div class="interaction-type-icon">
              <app-icon name="clipboard-pen" [size]="24" />
            </div>
            <div class="interaction-type-info">
              <h5>{{ form.name }}</h5>
            </div>
            <div class="interaction-type-arrow">
              <app-icon name="chevron-right" />
            </div>
          </button>
          }
        </div>
      </div>
    </div>
    }
  </app-card-content>
</app-card>